import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ServicePopupContext = createContext();

export const servicesData = [
  {
    id: 1,
    url: "/assets/img/services/naturalisation.jpg",
    url2: "/assets/img/services/naturalisation2.jpg",
    title: "Naturalisation - 990€",
    description:
      "Obtenez la nationalité française avec l’aide de nos avocats spécialisés",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce que la naturalisation ?
        </h3>
        <p className="mb-4">
          La naturalisation est l'une des procédures permettant d'acquérir la
          nationalité française. Elle constitue une faveur accordée par l'État
          français à un ressortissant étranger qui en fait la demande et qui
          remplit certaines conditions. Contrairement à d'autres modes
          d'acquisition de la nationalité, la naturalisation n'est pas un droit
          automatique, même si toutes les conditions sont remplies.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types de naturalisation ?
        </h3>
        <p className="mb-2">
          En France, il existe plusieurs voies de naturalisation :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>Naturalisation par décret</strong> : la procédure standard,
            accessible après 5 ans de résidence en France
          </li>
          <li>
            <strong>Naturalisation par mariage</strong> : accessible après 4 ans
            de mariage avec un conjoint français
          </li>
          <li>
            <strong>Naturalisation facilitée</strong> : pour certaines
            catégories comme les réfugiés (après 2 ans de résidence) ou les
            diplômés d'établissements supérieurs français
          </li>
          <li>
            <strong>Naturalisation pour services exceptionnels</strong> : sans
            condition de durée de résidence pour contributions remarquables à la
            France
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Constituer un dossier de naturalisation : que fournir ?
        </h3>
        <p className="mb-2">
          Pour constituer un dossier de naturalisation complet, vous devrez
          fournir :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>Formulaire de demande cerfa n°12753*03 dûment complété</li>
          <li>
            Justificatifs d'identité (passeport, titre de séjour en cours de
            validité)
          </li>
          <li>
            Actes d'état civil originaux et leur traduction par un traducteur
            assermenté
          </li>
          <li>
            Justificatifs de ressources (contrats de travail, bulletins de
            salaire des 3 derniers mois, avis d'imposition des 3 dernières
            années)
          </li>
          <li>
            Justificatifs de résidence (quittances de loyer, factures EDF, etc.)
          </li>
          <li>
            Diplôme attestant de votre niveau de français (niveau B1 minimum)
          </li>
          <li>Casier judiciaire du pays d'origine de moins de 3 mois</li>
          <li>Timbre fiscal dématérialisé de 55€</li>
          <li>Photographies d'identité</li>
        </ul>
        <p className="mb-4">
          Notre cabinet vous accompagne dans la constitution de ce dossier,
          vérifie sa complétude et sa conformité aux exigences de
          l'administration, et vous prépare également à l'entretien
          d'assimilation à la préfecture.
        </p>
      </>
    ),
  },
  {
    id: 2,
    url: "/assets/img/services/tds.jpg",
    url2: "/assets/img/services/tds2.jpg",
    title: "Titre de séjour - 1390€",
    description:
      "Obtenez ou renouvelez votre titre de séjour avec nos avocats spécialisés",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce qu'un titre de séjour ?
        </h3>
        <p className="mb-4">
          Un titre de séjour est un document officiel permettant à un
          ressortissant étranger de résider légalement sur le territoire
          français pour une durée déterminée. Ce document atteste de la
          régularité de votre séjour en France et vous donne droit à certaines
          démarches et avantages, comme travailler, étudier, ou accéder à la
          protection sociale, en fonction du type de titre obtenu.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types de titres de séjour ?
        </h3>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>Titre de séjour vie privée et familiale</strong> : pour les
            personnes ayant des attaches familiales en France
          </li>
          <li>
            <strong>Titre de séjour salarié/travailleur temporaire</strong> :
            pour les personnes ayant un contrat de travail en France
          </li>
          <li>
            <strong>Carte de séjour pluriannuelle</strong> : jusqu'à 4 ans après
            un premier titre d'un an
          </li>
          <li>
            <strong>Carte de résident</strong> : valable 10 ans, après plusieurs
            années de séjour régulier
          </li>
          <li>
            <strong>Passeport talent</strong> : pour les profils hautement
            qualifiés, entrepreneurs, artistes
          </li>
          <li>
            <strong>Titre de séjour étudiant</strong> : pour les étudiants
            inscrits dans un établissement d'enseignement français
          </li>
          <li>
            <strong>Titre de séjour pour soins</strong> : pour les étrangers
            malades ne pouvant être soignés dans leur pays
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Constituer un dossier de titre de séjour : que fournir ?
        </h3>
        <p className="mb-2">
          Les pièces à fournir dépendent du type de titre demandé, mais
          généralement vous devrez présenter :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>Formulaire de demande spécifique au type de titre sollicité</li>
          <li>Passeport en cours de validité</li>
          <li>Justificatif de domicile de moins de 3 mois</li>
          <li>Photos d'identité aux normes</li>
          <li>Actes d'état civil et leur traduction</li>
          <li>
            Justificatifs spécifiques selon le motif de la demande (contrat de
            travail, certificat de scolarité, liens familiaux, etc.)
          </li>
          <li>Timbre fiscal (montant variable selon le type de titre)</li>
        </ul>
        <p className="mb-4">
          Notre cabinet évalue votre situation pour déterminer le titre de
          séjour le plus adapté, prépare un dossier complet et argumenté, et
          vous représente auprès des autorités compétentes pour défendre vos
          droits et intérêts.
        </p>
      </>
    ),
  },
  {
    id: 3,
    url: "/assets/img/services/oqtf.jpg",
    url2: "/assets/img/services/oqtf2.jpg",
    title: "OQTF - 1390€",
    description:
      "Faites face à une Obligation de Quitter le Territoire Français avec nos avocats spécialisés",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce qu'une OQTF ?
        </h3>
        <p className="mb-4">
          L’OQTF (Obligation de Quitter le Territoire Français) est une décision
          administrative prise par les autorités françaises, ordonnant à un
          ressortissant étranger de quitter la France dans un délai déterminé,
          généralement de 30 jours. Cette décision peut être accompagnée d'une
          interdiction de retour sur le territoire français (IRTF) pour une
          durée variable. L’OQTF survient souvent après un refus de titre de
          séjour, un non-renouvellement ou en cas de séjour irrégulier.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types d'OQTF ?
        </h3>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>OQTF avec délai de départ volontaire</strong> : vous
            disposez généralement de 30 jours pour quitter le territoire
          </li>
          <li>
            <strong>OQTF sans délai de départ volontaire</strong> : applicable
            en cas de menace à l'ordre public, de fraude ou lorsque le risque de
            fuite est avéré
          </li>
          <li>
            <strong>OQTF avec interdiction de retour</strong> : assortie d'une
            interdiction de revenir en France pour une durée de 1 à 5 ans
          </li>
          <li>
            <strong>OQTF pour ressortissants de l'Union Européenne</strong> :
            applicable sous conditions spécifiques (menace grave à l'ordre
            public ou abus de droit)
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Constituer un dossier de recours contre une OQTF : que fournir ?
        </h3>
        <p className="mb-2">
          Pour contester efficacement une OQTF, vous devez rassembler :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>La décision d'OQTF complète et sa notification</li>
          <li>
            Tout document attestant de votre situation personnelle (santé,
            famille, durée de présence en France)
          </li>
          <li>
            Justificatifs de votre intégration en France (contrats de travail,
            diplômes, attestations de formation, témoignages)
          </li>
          <li>
            Preuves des risques en cas de retour dans votre pays d'origine, le
            cas échéant
          </li>
          <li>
            Documents relatifs à votre vie privée et familiale en France (actes
            de naissance des enfants, certificat de mariage, PACS, etc.)
          </li>
          <li>
            Justificatifs médicaux si votre état de santé nécessite des soins en
            France
          </li>
        </ul>
        <p className="mb-4">
          Notre cabinet vous assiste dans la contestation des OQTF dans les
          délais contraints du recours (48h, 15 jours ou 30 jours selon les
          cas), élabore une stratégie juridique adaptée, et vous représente
          devant le tribunal administratif pour défendre vos droits au séjour en
          France.
        </p>
      </>
    ),
  },
  {
    id: 4,
    url: "/assets/img/services/acceleration.jpg",
    url2: "/assets/img/services/acceleration2.jpg",
    title: "Accélération des procédures - à partir de 1000€",
    description:
      "Gagnez du temps avec notre service spécialisé",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce que l'accélération des procédures ?
        </h3>
        <p className="mb-4">
          L'accélération des procédures est un service juridique dédié à réduire
          les délais de traitement excessivement longs des dossiers de droit des
          étrangers. Face aux retards fréquents des préfectures et autres
          administrations françaises, nos experts mettent en place des leviers
          juridiques efficaces pour contraindre l’administration à examiner les
          dossiers dans un délai raisonnable, conformément au droit
          administratif français. Et tout cela, à des prix défiant toute
          concurrence.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types d'accélération des procédures ?
        </h3>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>Référé mesures utiles</strong> : procédure d'urgence pour
            contraindre l'administration à examiner un dossier
          </li>
          <li>
            <strong>Intervention directe</strong> : prise de contact avec les
            services administratifs pour débloquer un dossier
          </li>
          <li>
            <strong>Référé-liberté</strong> : en cas d'atteinte grave à une
            liberté fondamentale nécessitant une intervention en 48h
          </li>
          <li>
            <strong>Recours en carence</strong> : contestation de l'inaction
            administrative devant le tribunal
          </li>
          <li>
            <strong>
              Demande de rendez-vous via le tribunal administratif
            </strong>{" "}
            : pour obtenir un rendez-vous en préfecture
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Constituer un dossier d'accélération des procédures : que fournir ?
        </h3>
        <p className="mb-2">
          Pour accélérer efficacement votre procédure, nous aurons besoin de :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            Preuves des démarches déjà effectuées (récépissés, accusés de
            réception, copies des courriers envoyés)
          </li>
          <li>
            Justificatifs des relances effectuées (courriers recommandés,
            emails, tentatives de prise de rendez-vous)
          </li>
          <li>
            Documents attestant de l'urgence de votre situation (expiration
            imminente de titre, situation professionnelle ou familiale)
          </li>
          <li>
            Dossier complet initialement déposé auprès de l'administration
          </li>
          <li>
            Tout élément prouvant le préjudice subi du fait du retard
            administratif
          </li>
        </ul>
        <p className="mb-4">
          Notre cabinet met à profit son expertise du contentieux administratif
          pour identifier la procédure d'accélération la plus adaptée à votre
          situation. Nous intervenons rapidement pour faire valoir vos droits
          face à l'administration et obtenir une réponse dans les meilleurs
          délais.
        </p>
      </>
    ),
  },
  {
    id: 5,
    url: "/assets/img/services/regroupement.jpg",
    url2: "/assets/img/services/regroupement2.jpg",
    title: "Regroupement familial - 1390€",
    description:
      "Réunissez votre famille en France en toute légalité",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce que le regroupement familial ?
        </h3>
        <p className="mb-4">
          Le regroupement familial est une procédure légale permettant à un
          ressortissant étranger résidant régulièrement en France depuis au
          moins 18 mois de faire venir son conjoint et ses enfants mineurs. Ce
          droit fondamental, encadré par le Code de l'entrée et du séjour des
          étrangers et du droit d'asile (CESEDA), vise à garantir l'unité
          familiale tout en veillant à ce que les conditions d’accueil en France
          soient respectées et adéquates.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types de regroupement familial ?
        </h3>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>Regroupement familial standard</strong> : pour les
            ressortissants hors UE souhaitant faire venir leur conjoint et
            enfants mineurs
          </li>
          <li>
            <strong>Regroupement familial des réfugiés</strong> : procédure
            spécifique pour les bénéficiaires de la protection internationale
          </li>
          <li>
            <strong>Réunification familiale</strong> : procédure particulière
            pour les bénéficiaires de la protection subsidiaire et les apatrides
          </li>
          <li>
            <strong>Regroupement sur place</strong> : pour les membres de
            famille déjà présents en France
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Constituer un dossier de regroupement familial : que fournir ?
        </h3>
        <p className="mb-2">
          Pour constituer un dossier complet de regroupement familial, vous
          devrez fournir :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>Formulaire Cerfa n°11436*05 dûment complété</li>
          <li>Titre de séjour en cours de validité du demandeur</li>
          <li>
            Justificatifs de ressources stables et suffisantes (bulletins de
            salaire des 12 derniers mois, avis d'imposition)
          </li>
          <li>
            Justificatif de logement adapté à la taille de la famille (bail,
            acte de propriété, attestation de mise à disposition)
          </li>
          <li>
            Actes d'état civil des membres de la famille concernés (acte de
            mariage, actes de naissance des enfants)
          </li>
          <li>Copie intégrale des passeports des membres de la famille</li>
          <li>Photos d'identité récentes de chaque membre de la famille</li>
          <li>Timbres fiscaux</li>
        </ul>
        <p className="mb-4">
          Notre cabinet vous guide à chaque étape de cette procédure complexe,
          depuis la constitution du dossier initial jusqu'à l'obtention des
          visas et titres de séjour pour votre famille, en passant par la visite
          du logement et l'enquête administrative.
        </p>
      </>
    ),
  },
  {
    id: 6,
    url: "/assets/img/services/dossierbloque.jpg",
    url2: "/assets/img/services/dossierbloque2.jpg",
    title: "Dossier bloqué en préfecture - à partir 1000€",
    description:
      "Retrouver la sérénité grâce à notre expertise",
    fullContent: (
      <>
        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Qu'est-ce qu'un dossier bloqué en préfecture ?
        </h3>
        <p className="mb-4">
          Un dossier bloqué en préfecture survient lorsque votre demande de
          titre de séjour, de renouvellement, ou d’une autre démarche
          administrative reste sans réponse pendant une période anormalement
          longue. Cela peut aussi se produire lorsque vous rencontrez des
          difficultés à obtenir un rendez-vous. Les causes sont multiples :
          engorgement des services, problèmes techniques, complexité du dossier,
          ou demandes de documents supplémentaires. Nos experts se chargent de
          tout pour vous permettre de dépasser ces obstacles.
        </p>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Quels sont les différents types de blocages administratifs ?
        </h3>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            <strong>Impossibilité d'obtenir un rendez-vous</strong> :
            plateformes saturées, absence de créneaux disponibles
          </li>
          <li>
            <strong>Silence de l'administration</strong> : absence de réponse
            après le dépôt d'un dossier complet
          </li>
          <li>
            <strong>
              Multiplication des demandes de pièces complémentaires
            </strong>{" "}
            : parfois non justifiées ou déjà fournies
          </li>
          <li>
            <strong>Retards dans la fabrication ou la remise des titres</strong>{" "}
            : après décision favorable
          </li>
          <li>
            <strong>Blocages liés à des vérifications particulières</strong> :
            enquêtes administratives prolongées
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-3 text-blue-900">
          Débloquer un dossier en préfecture : que fournir ?
        </h3>
        <p className="mb-2">
          Pour nous permettre d'intervenir efficacement, nous aurons besoin de :
        </p>
        <ul className="list-disc pl-5 mb-4 space-y-2">
          <li>
            Copie de toutes les correspondances avec la préfecture (courriers,
            emails, récépissés)
          </li>
          <li>
            Preuves des tentatives de prise de rendez-vous (captures d'écran,
            historique de connexion)
          </li>
          <li>Copie complète du dossier initialement déposé</li>
          <li>
            Justificatifs de vos relances (accusés de réception, dates des
            visites en préfecture)
          </li>
          <li>
            Tout document attestant de l'urgence de votre situation (expiration
            imminente de documents, conséquences professionnelles ou
            personnelles)
          </li>
          <li>
            Copies des récépissés ou autorisations provisoires de séjour en
            votre possession
          </li>
        </ul>
        <p className="mb-4">
          Notre cabinet mobilise différents leviers juridiques pour résoudre les
          blocages administratifs : intervention directe auprès des services
          préfectoraux, recours gracieux, référés administratifs, ou saisine du
          Défenseur des droits. Nous identifions la stratégie la plus appropriée
          à votre situation pour obtenir une réponse rapide de l'administration.
        </p>
      </>
    ),
  },
];

export const ServicePopupProvider = ({ children }) => {
  const [selectedService, setSelectedService] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const openPopup = (serviceId) => {
    const service = servicesData.find((s) => s.id === serviceId);
    if (service) {
      setSelectedService(service);
      setTimeout(() => {
        setIsOpen(true);
      }, 50);
    }
  };

  const closePopup = () => {
    setIsOpen(false);
    setTimeout(() => {
      setSelectedService(null);
    }, 300);
  };

  return (
    <ServicePopupContext.Provider
      value={{
        openPopup,
        closePopup,
        servicesData,
      }}
    >
      {children}

      {selectedService && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center transition-all duration-500 ease-in-out ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={closePopup}
        >
          <div
            className={`bg-white rounded-lg w-full max-w-5xl transform transition-all duration-500 ease-in-out ${
              isOpen
                ? "scale-100 translate-y-0 opacity-100"
                : "scale-95 translate-y-8 opacity-0"
            }`}
            onClick={(e) => e.stopPropagation()}
            style={{ maxHeight: "90vh" }}
          >
            <div className="flex flex-col md:flex-row h-full">
              <div className="md:w-1/2 h-64 md:h-auto">
                <div className="h-full">
                  <img
                    src={selectedService.url2}
                    alt={selectedService.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="md:w-1/2 flex flex-col max-h-[90vh]">
                <div className="p-4 border-b">
                  <button
                    onClick={closePopup}
                    className="float-right text-gray-500 hover:text-black focus:outline-none z-20"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                  <h2 className="text-2xl font-bold text-blue-900">
                    {selectedService.title}
                  </h2>
                </div>

                <div
                  className="p-4 overflow-y-auto overflow-x-hidden"
                  style={{ maxHeight: "55vh" }}
                >
                  <p className="mb-4 text-gray-600">
                    {selectedService.description}
                  </p>
                  <div className="flex justify-center mb-4">
                    <button
                      className={`${
                        selectedService.id <= 3 ? "banner-btn2" : "banner-btn"
                      } text-white px-8 py-3 button-red rounded-full font-medium transition-all hover:shadow-lg`}
                      onClick={() => {
                        closePopup();
                        navigate("/contact");
                      }}
                    >
                      Prendre rendez-vous
                    </button>
                  </div>
                  {selectedService.fullContent ? (
                    <div className="mt-2 text-gray-600">
                      {selectedService.fullContent}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ServicePopupContext.Provider>
  );
};

export const useServicePopup = () => {
  const context = useContext(ServicePopupContext);
  if (!context) {
    throw new Error(
      "useServicePopup must be used within a ServicePopupProvider",
    );
  }
  return context;
};
